import { createSelector } from 'reselect';
import { contains } from 'underscore';
import { CriterionTypes, CriterionTypeParameterKeys, RequestStatus } from 'smart-content-core/constants';
import { getIlsListsFetchStatuses } from 'smart-content-core/selectors/IlsLists';
import { getAdSourceFetchStatus as getAdSourceListStatus } from 'smart-content-core/selectors/AdSourceSelectors';
const ILS_CONTACT_LIST_PARAMETER_KEY = CriterionTypeParameterKeys[CriterionTypes.CONTACT_LIST];
export const getCriterion = (state, props) => {
  return state.criteria.byId[props.criterionId];
};
export const makeAdSourceCriterionFetchStatus = () => {
  return createSelector([getCriterion, getAdSourceListStatus], (criterion, fetchStatusById) => {
    if (!(criterion && criterion.type === CriterionTypes.AD_SOURCE)) {
      return null;
    }
    const status = fetchStatusById[criterion.id] || RequestStatus.UNINITIALIZED;
    if (status === RequestStatus.UNINITIALIZED) {
      return RequestStatus.UNINITIALIZED;
    } else if (status === RequestStatus.PENDING) {
      return RequestStatus.PENDING;
    } else if (status === RequestStatus.FAILED) {
      return RequestStatus.FAILED;
    } else {
      return RequestStatus.SUCCEEDED;
    }
  });
};
export const makeGetContactListCriterionFetchStatus = () => {
  const defaultStatus = RequestStatus.UNINITIALIZED;
  let fetchStatus = defaultStatus;
  return createSelector([getCriterion, getIlsListsFetchStatuses], (criterion, fetchStatusByIlsId) => {
    if (!(criterion && criterion.type === CriterionTypes.CONTACT_LIST)) {
      return null;
    }
    const contactListParams = criterion.parameters;
    const ilsListIds = contactListParams[ILS_CONTACT_LIST_PARAMETER_KEY];
    const listFetchStatuses = ilsListIds.map(ilsListId => {
      return fetchStatusByIlsId[ilsListId] || RequestStatus.UNINITIALIZED;
    });
    if (contains(listFetchStatuses, RequestStatus.UNINITIALIZED)) {
      fetchStatus = RequestStatus.UNINITIALIZED;
    } else if (contains(listFetchStatuses, RequestStatus.PENDING)) {
      fetchStatus = RequestStatus.PENDING;
    } else if (contains(listFetchStatuses, RequestStatus.FAILED)) {
      fetchStatus = RequestStatus.FAILED;
    } else {
      fetchStatus = RequestStatus.SUCCEEDED;
    }
    return fetchStatus;
  });
};